var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgInternationalHenry = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 222,
    viewBox: "0 0 286 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M247.234 96.4664C240.392 97.7995 237.688 97.7555 234.872 97.7555C231.419 97.7555 227.737 103.796 225.718 111.838C221.126 116.849 211.986 105.432 210.715 103.582C211.349 94.5658 216.323 86.8563 228.535 84.3773C232.103 83.6529 234.168 83.4227 236.593 82.8566C239.276 82.2303 241.01 76.6697 245.801 75.4403C250.592 74.211 252.81 74.9624 255.375 74.4626C257.288 74.09 257.593 75.2141 257.364 75.5547C257.134 75.8953 257.926 76.9246 253.309 77.5282C248.693 78.1319 246.349 79.7721 246.286 80.968C246.223 82.1639 245.82 83.1303 247.356 83.4227C248.585 83.6566 255.141 83.3702 258.388 83.3294C259.039 82.3138 259.58 81.4527 259.9 80.9787C261.048 79.2755 262.814 79.2273 262.98 80.0826C262.992 80.1433 262.984 80.2454 262.957 80.383C263.512 79.0913 264.698 78.2684 266.124 77.9906C266.616 77.8947 266.766 78.2181 266.731 78.76C266.948 78.1259 267.782 76.7799 269.378 76.4688C270.277 76.2936 270.397 77.0518 270.204 78.0833C270.385 77.3576 271.044 75.9075 272.229 75.9134C273.71 75.9207 273.077 77.2277 273.014 78.4236C272.951 79.6195 270.578 87.1836 269.375 88.6017C268.412 89.7361 266.671 89.9175 265.921 89.8664C265.626 90.3418 265.321 90.7144 265.012 90.9312C263.612 91.9142 262.013 91.8243 261.389 91.6564C260.89 92.3136 260.384 92.8255 259.894 93.0997C257.973 94.1744 255.863 94.177 255.048 94.044C253.534 94.8616 251.177 95.6982 247.234 96.4664Z",
    fill: "#FAE900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M243.954 91.7792C245.775 92.0161 251.533 91.1903 253.132 90.2868C253.624 90.0088 254.346 89.1814 255.143 88.1196M255.048 94.044C253.534 94.8616 251.177 95.6982 247.234 96.4664C240.392 97.7995 237.688 97.7555 234.872 97.7555C231.419 97.7555 227.737 103.796 225.718 111.838C221.126 116.849 211.986 105.432 210.715 103.582C211.349 94.5658 216.323 86.8563 228.535 84.3773C232.103 83.6529 234.168 83.4227 236.593 82.8566C239.276 82.2303 241.01 76.6697 245.801 75.4403C250.592 74.211 252.81 74.9624 255.375 74.4626C257.288 74.09 257.593 75.2141 257.364 75.5547C257.134 75.8953 257.926 76.9246 253.309 77.5282C248.693 78.1319 246.349 79.7721 246.286 80.968C246.223 82.1639 245.82 83.1303 247.356 83.4227C248.585 83.6567 255.141 83.3702 258.388 83.3294M255.048 94.044C256.817 93.088 257.434 92.158 258.082 91.3937C259.2 90.0763 262.612 82.1832 262.957 80.383M255.048 94.044C255.863 94.177 257.973 94.1744 259.894 93.0997C260.384 92.8255 260.89 92.3136 261.389 91.6564M262.957 80.383C262.984 80.2454 262.992 80.1433 262.98 80.0826C262.814 79.2273 261.048 79.2755 259.9 80.9787C259.314 81.8484 257.979 84.0216 256.599 86.0604M262.957 80.383C263.512 79.0913 264.698 78.2684 266.124 77.9906C266.616 77.8947 266.766 78.2181 266.731 78.76M266.731 78.76C266.664 79.7876 265.929 81.6007 265.587 82.8297C265.171 84.3237 263.333 89.0941 261.389 91.6564M266.731 78.76C266.948 78.1259 267.782 76.7799 269.378 76.4688C270.277 76.2936 270.397 77.0518 270.204 78.0833M261.389 91.6564C262.013 91.8243 263.612 91.9142 265.012 90.9312C265.321 90.7144 265.626 90.3418 265.921 89.8664M265.921 89.8664C267.299 87.6476 268.477 83.1892 268.952 81.8781C269.27 81.0036 269.969 79.3405 270.204 78.0833M265.921 89.8664C266.671 89.9175 268.412 89.7361 269.375 88.6017C270.578 87.1836 272.951 79.6195 273.014 78.4236C273.077 77.2277 273.71 75.9207 272.229 75.9134C271.044 75.9075 270.385 77.3576 270.204 78.0833M247.271 89.0615C249.156 88.8916 253.369 88.4653 255.143 88.1196M255.143 88.1196C255.613 87.4933 256.109 86.7853 256.599 86.0604M252.069 86.3512L256.599 86.0604",
    stroke: "#040222",
    strokeWidth: 1.83549,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3474 195.757L49.2868 195.757C49.2868 195.757 68.8169 83.4118 77.745 73.9141C86.6589 64.4178 104.417 61.2198 104.417 61.2198C104.417 61.2198 128.611 57.674 151.761 64.9258C170.374 72.4138 184.175 143.628 184.175 143.628L213.748 93.5314C213.748 93.5314 216.564 97.7561 232.759 98.4602C214.285 131.599 195.999 193.396 183.2 195.167C170.4 196.939 155.964 143.628 155.964 143.628L147.002 190.72L88.3474 195.757Z",
    fill: "#5D21D2",
    stroke: "#040222",
    strokeWidth: 1.83549,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155.936 143.63L160.707 114.26",
    stroke: "#040222",
    strokeWidth: 1.83549,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M148.271 114.543C148.164 114.437 148.168 114.259 148.278 114.156L150.38 112.186C150.49 112.082 150.674 112.085 150.78 112.191L154.879 116.288C155.018 116.435 155.098 116.621 155.094 116.831C155.09 117.049 154.995 117.241 154.851 117.376L150.494 121.46C150.443 121.507 150.368 121.539 150.293 121.537L146.161 121.48C146.003 121.478 145.88 121.355 145.883 121.202C145.884 121.121 145.919 121.049 145.978 121.002L150.301 116.95C150.352 116.902 150.387 116.83 150.388 116.758C150.39 116.685 150.366 116.62 150.308 116.563L148.271 114.543Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 0.917746
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M145.394 116.51C145.501 116.616 145.498 116.793 145.387 116.896L143.285 118.867C143.175 118.97 142.992 118.968 142.885 118.861L138.786 114.765C138.647 114.618 138.567 114.431 138.571 114.221C138.575 114.004 138.67 113.812 138.814 113.677L143.171 109.585C143.222 109.537 143.298 109.506 143.373 109.507L147.504 109.564C147.662 109.567 147.785 109.689 147.782 109.842C147.781 109.923 147.746 109.995 147.687 110.043L143.364 114.095C143.313 114.15 143.279 114.214 143.277 114.287C143.276 114.36 143.3 114.424 143.357 114.482C143.357 114.474 145.394 116.51 145.394 116.51Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 0.917746
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M135.385 63.5722C141.513 62.3302 143.994 57.8444 143.994 57.8444C147.829 52.7975 145.994 32.7804 145.272 21.1C144.551 9.41958 133.948 5.75503 126.091 8.17143C118.233 10.5878 116.252 22.8724 116.252 22.8724C115.734 25.1378 112.565 37.7845 111.855 40.8116C111.145 43.8387 108.074 59.3301 108.074 59.3301L104.819 61.3217C104.819 61.3217 106.242 61.7887 107.354 62.4002C109.482 62.8497 110.702 70.2936 112.031 74.1433C113.358 77.9792 117.122 81.2666 125.727 80.8154C134.319 80.3796 136.505 76.4705 136.692 73.0782C136.648 73.0688 136.735 71.8561 135.385 63.5722Z",
    fill: "#FAE900",
    stroke: "#040222",
    strokeWidth: 1.83549,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M146.037 39.6071C146.037 39.6071 131.428 40.0278 126.628 38.696C123.546 34.1617 124.048 32.8218 121.309 34.2976C118.569 35.7734 117.154 51.6936 119.213 57.0765C121.27 62.4455 130.504 65.1475 135.848 63.4976C141.176 61.8353 145.916 57.9533 145.994 50.7936C146.073 43.6339 146.037 39.6071 146.037 39.6071Z",
    fill: "#9C768C",
    stroke: "#040222",
    strokeWidth: 0.917746,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M120.807 29.6474C120.807 29.6474 116.395 27.7992 115.865 31.7312C115.335 35.6632 118.996 35.6445 118.996 35.6445",
    stroke: "#040222",
    strokeWidth: 0.917746,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M135.918 37.5564C135.918 37.5564 135.646 37.4168 138.545 36.5121C137.432 34.865 137.007 30.1092 137.007 30.1092",
    stroke: "#040222",
    strokeWidth: 0.917746,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M133.39 31.1312C133.39 31.1312 131.068 27.875 126.942 30.5314",
    stroke: "#040222",
    strokeWidth: 0.917746,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M130.383 29.4994L130.305 31.8866",
    stroke: "#040222",
    strokeWidth: 0.917746,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M144.385 31.9831C144.385 31.9831 142.674 29.1109 138.825 31.2904",
    stroke: "#040222",
    strokeWidth: 0.917746,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M141.59 30.6094L141.756 32.7472",
    stroke: "#040222",
    strokeWidth: 0.917746,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M134.232 26.761C134.232 26.761 135.313 24.143 131.405 24.1175C127.495 24.0781 122.738 24.5192 122.997 26.9972C123.256 29.4753 125.988 27.5244 129.733 27.623C133.479 27.7354 134.232 26.761 134.232 26.761Z",
    fill: "#9C768C",
    stroke: "#040222",
    strokeWidth: 0.917746,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M145.055 25.8546C145.055 25.8546 142.416 24.465 139.443 24.6636C136.471 24.8622 136.892 26.7075 137.336 27.2769C137.794 27.8447 141.084 28.4947 142.215 28.5445C143.346 28.5942 145.452 29.102 145.384 28.4513C145.328 27.7854 145.055 25.8546 145.055 25.8546Z",
    fill: "#9C768C",
    stroke: "#040222",
    strokeWidth: 0.917746,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M129.205 10.4365C127.324 10.0312 126.25 10.9411 125.301 12.0899C124.352 13.2386 124.901 13.8531 126.214 13.324C127.515 12.8103 129.895 12.2677 130.375 12.2176C130.854 12.1675 131.889 11.0237 129.205 10.4365Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 0.917746,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M137.681 37.1201C137.681 37.1201 137.777 38.9994 135.898 38.342C135.47 38.0648 135.579 37.6056 135.579 37.6056L137.681 37.1201Z",
    fill: "#040222"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M119.21 57.0762C119.21 57.0762 118.063 74.7458 135.413 69.7283C135.134 64.3274 135.845 63.4973 135.845 63.4973C135.845 63.4973 125.716 66.277 119.21 57.0762Z",
    fill: "#040222"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M130.136 42.63C131.872 41.5401 132.06 43.3374 136.73 43.7579C139.57 44.3697 140.767 46.97 135.275 47.5437C129.784 48.1174 128.399 43.7199 130.136 42.63Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 0.917746,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M132.351 42.9396L130.69 46.1912M134.615 43.6761L134.076 47.3663M137.158 44.0608L137.201 46.92",
    stroke: "#040222",
    strokeWidth: 0.917746,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000244141 195.443L265.395 196.962",
    stroke: "#040222",
    strokeWidth: 1.83549
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8589 115.566C74.8589 115.566 76.7313 198.296 88.7169 206.387C100.703 214.479 115.609 206.005 133.027 201.197C137.141 191.267 129.54 186.89 129.54 186.89L112.688 186.633C108.681 186.574 105.413 183.471 105.199 179.548L101.084 102.686",
    fill: "#5D21D2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8589 115.566C74.8589 115.566 76.7313 198.296 88.7169 206.387C100.703 214.479 115.609 206.005 133.027 201.197C137.141 191.267 129.54 186.89 129.54 186.89L112.688 186.633C108.681 186.574 105.413 183.471 105.199 179.548L101.084 102.686",
    stroke: "#040222",
    strokeWidth: 1.83549,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M124.546 186.657C133.171 185.619 150.113 183.714 160.959 191.182C163.278 192.29 164.436 193.679 164.901 194.652C164.902 194.652 164.902 194.652 164.902 194.652C164.902 194.652 164.902 194.652 164.901 194.652C165.345 195.579 165.16 196.128 164.753 195.695C164.554 195.484 164.341 195.277 164.102 195.075C162.042 195.209 157.085 195.379 152.343 195.063C146.241 194.656 146.106 196.012 132.275 201.436C134.011 193.084 127.846 188.103 124.546 186.657Z",
    fill: "#FAE900",
    stroke: "#040222",
    strokeWidth: 1.83549,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M229.453 10.0715L234.047 7.56629C234.902 7.1 235.938 7.11261 236.782 7.5996L270.029 26.7948C271.093 27.4095 271.826 28.1722 271.977 29.1398L267.55 31.7018L229.453 10.0715Z",
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 1.19466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M267.854 31.1741L271.777 28.6092C272.127 29.2335 272.003 29.5204 272.041 30.0702L272.193 58.3542C272.198 59.3242 271.7 60.2275 270.876 60.7406L267.039 63.1321L267.854 31.1741Z",
    fill: "#F7F4FD",
    stroke: "#040222",
    strokeWidth: 1.19466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M267.898 61.6316L268.062 32.1336C268.065 31.5062 267.732 30.9252 267.189 30.6116L231.419 9.95979C230.255 9.28824 228.801 10.1263 228.799 11.4694L228.753 41.035C228.752 41.6599 229.085 42.2377 229.626 42.5501L265.279 63.1343C266.439 63.8043 267.891 62.9716 267.898 61.6316Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 1.19466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M247.115 44.877L261.723 53.6305",
    stroke: "#040222",
    strokeWidth: 1.19466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M261.779 44.123L261.756 38.7305C261.754 38.3625 261.553 38.0228 261.231 37.843L255.925 34.8835C255.247 34.5057 254.418 34.9922 254.421 35.7656L254.443 40.7706C254.444 41.119 254.624 41.4436 254.92 41.63L260.228 44.977C260.905 45.4039 261.782 44.921 261.779 44.123Z",
    fill: "#F7F4FD",
    stroke: "black",
    strokeWidth: 0.597331
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M258.001 35.8516L258.011 38.7208M258.027 43.3364L258.018 40.8415M258.018 40.8415L261.437 42.631M258.018 40.8415L258.011 38.7208M258.018 40.8415L254.379 38.9146M258.011 38.7208L261.617 40.4797M258.011 38.7208L254.372 36.8371",
    stroke: "black",
    strokeWidth: 0.597331
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M236.98 38.8873C234.346 39.4577 233.301 36.1715 233.535 34.32C234.286 32.0229 235.634 31.4938 237.723 31.9205C238.355 32.0496 238.902 32.6498 239.249 33.4504C239.678 33.4262 240.151 33.4733 240.669 33.5791C242.759 34.0059 243.914 39.5792 240.004 40.528C238.52 40.888 237.53 40.0369 236.98 38.8873Z",
    fill: "#F1B9FF",
    stroke: "black",
    strokeWidth: 1.19466
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInternationalHenry);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/internationalHenry.5cbd9929f1bcf0642e595185f49abf45.svg";